var close = document.getElementsByClassName('close-gallery');

$('.gallery-link').on('click', function () {
    $('.overview-experience--gallery').addClass('opened');
    $('body').addClass('no-scroll');
    $('.gallery-button-next').removeClass('swiper-button-disabled');
    $('.gallery-button-prev').removeClass('swiper-button-disabled');

    const offset = -250;
    const overview = document.getElementsByClassName('overview-experience--gallery');
    const final = overview[0].getBoundingClientRect().top + window.pageYOffset + offset;
    console.log(final);
    window.scrollTo({top: final});
    const newDiv = document.createElement("div");

    newDiv.classList.add('view-gallery-overlay');
    close[0].classList.add('open');

    const currentDiv = document.getElementById("page"); 
    document.body.insertBefore(newDiv, currentDiv);
})

$('.close-gallery').on('click', function() {
    if ($('.close-gallery').hasClass('open')) {
        $('.overview-experience--gallery').removeClass('opened');
        close[0].classList.remove('open');
        $('.view-gallery-overlay').remove();
        $('body').removeClass('no-scroll');
    }
})